import { useEffect } from "react";

import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

// Material Dashboard 2 PRO React components
import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";

import Chip from "@mui/material/Chip";

import { areaEnum, areaColor } from "../../../config/enum";

export default function UserInfos({
  username,
  setUsername,
  password,
  setPassword,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  userAreas,
  setUserAreas,
  edit,
}) {
  useEffect(() => {
    if (!edit) {
      setUsername(
        firstName.toLowerCase() +
          lastName
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstName, lastName]);

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={firstName}
            onChange={(event) => setFirstName(event.target.value)}
            variant="standard"
            required
            type="text"
            label="Prénom"
          />
        </Grid>
        <Grid item xs={6}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={lastName}
            onChange={(event) => setLastName(event.target.value.toUpperCase())}
            required
            variant="standard"
            type="text"
            label="Nom"
          />
        </Grid>
        {firstName !== "" && lastName !== "" && (
          <>
            <Grid item xs={6}>
              <FormField
                inputProps={{ maxLength: 255 }}
                value={username}
                onChange={(event) => setUsername(event.target.value)}
                required
                variant="standard"
                type="text"
                label="Nom d'utilisateur"
              />
            </Grid>
            {!edit && (
              <Grid item xs={6}>
                <FormField
                  inputProps={{ maxLength: 255 }}
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  required
                  autocomplete="thengt"
                  variant="standard"
                  type="password"
                  label="Mot de passe"
                />
              </Grid>
            )}
          </>
        )}
        <Grid item xs={6}>
          <Autocomplete
            multiple
            options={areaEnum}
            value={userAreas}
            onChange={(event, newAreas) => {
              setUserAreas(newAreas || []);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  label={option}
                  {...getTagProps({ index })}
                  key={option}
                  sx={{
                    backgroundColor: `${areaColor[option] || "#888"} !important`,
                    color: "#fff !important",
                    fontWeight: "bold",
                    "& .MuiChip-deleteIcon": { color: "rgba(255,255,255,0.7) !important", "&:hover": { color: "#fff !important" } },
                  }}
                />
              ))
            }
            renderOption={(props, option) => (
              <MDBox
                component="li"
                {...props}
                style={{ color: areaColor[option], fontWeight: "bold" }}
              >
                {option}
              </MDBox>
            )}
            renderInput={(params) => (
              <MDInput
                {...params}
                label="Secteurs de l'utilisateur"
                variant="standard"
              />
            )}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
